module.exports = __webpack_public_path__ + "media/img/pages/companies/stadt-zurich-horizontal-78cd3e1a96b09cb59acda81835716097.png";